import { hexToRgb } from '@website/common/utils'

export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    dotColor: p => p.tertiaryDark,
    primaryBlock: p => p.primaryLight,
    line: p => `rgba(${hexToRgb(p.accentWhite)}, 0.5)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight,
    dotColor: p => p.tertiarySemiLight,
    primaryBlock: p => p.primaryDark,
    line: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.8)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    dotColor: p => p.tertiarySemiLight,
    primaryBlock: p => p.primaryDark,
    line: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.8)`
  }
}
